"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardItemContent = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
exports.DashboardItemContent = react_1.forwardRef(function DashboardItemContent(_a, ref) {
    var children = _a.children, className = _a.className;
    return (react_1.default.createElement("div", { className: classnames_1.default("dash-item-content", className), ref: ref }, children));
});
//# sourceMappingURL=DashboardItemContent.js.map